import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  MARKETPLACE_LISTING_SORY_BY,
  MARKETPLACE_LISTING_CONDITIONS,
  MARKETPLACE_LISTING_COLOR_OPTIONS,
  MARKETPLACE_LISTING_YEAR_OPTIONS,
  BREAKPOINT_EXTRA_SMALL,
} from '../../constants'
import {
  changeMarketplaceListingSearchAttr,
  fetchMarketplaceListingsBySearch,
  marketplaceSearchReset,
  resetMarketplaceListingSearchInnerAttrs,
} from '../../actions/marketplace_listing_search'
import {
  fetchMarketplaceListingCategories
} from '../../actions/marketplace_listing_categories'
import { isTouch } from '../../utils/is_mobile'
import PanelLayout from './panel_layout'
import Select from '../select'
import Text from '../text'
import Button from '../button'
import Input from '../input'
import Icon from '../icon'
import Dummy from '../dummy'
import Switch from '../switch'

class MarketplaceListingFilterPanel extends React.PureComponent {

  state = {
    isAdvancedOpen: isTouch(),
  }

  componentDidMount() {
    this._checkIfHasCategories()
  }

  componentDidUpdate(prevProps) {
    this._checkIfHasCategories()
  }

  _checkIfHasCategories = () => {
    if (!this.props.categoriesIsFetched) {
      this.props.onFetchMarketplaceListingCategories()
    }
  }

  handleOnReset = () => {
    this.props.onResetMarketplaceListingSearch()
  }

  handleOnSubmit = (e) => {
    e.preventDefault()
    const{  history, onClose, filters, categories } = this.props

    try {
      if (filters && !!categories && !!filters.get('category_slug') && !!filters.get('category_id')) {
        const slugCategory = categories.find((c) => c.get('slug') === filters.get('category_slug'))
        const idCategory = categories.find((c) => `${c.get('id')}` === `${filters.get('category_id')}`)
        if (!!slugCategory && !!idCategory && slugCategory.get('id') !== idCategory.get('id')) {
          // if has category slug and selected a different category id, reset categorySlug
          this.handleOnChangeAttr('category_slug', undefined)
        }
      }
    } catch (error) {
      // 
    }

    try {
      this.props.onFetchMarketplaceListingsBySearch(history)
      !!onClose && onClose()
    } catch (error) {
      // console.log("Error with submitting Gab Marketplace listing search: ", error)
    }
  }

  handleOnClose = () => {
    const { onClose } = this.props
    !!onClose && onClose()
  }

 	handleOnChangeAttr = (key, value) => {
		this.props.onChangeMarketplaceListingSearchAttr(key, value)
    // If changed category, need to make delete the old category attrs
    if (key === 'category_id') {
      this.props.onResetMarketplaceListingSearchInnerAttrs()
    }
	}

  toggleIsAdvancedOpen = () => {
    const { isAdvancedOpen } = this.state
    this.setState({ isAdvancedOpen: !isAdvancedOpen })
  }
  
  keypress = (evt) => {
    if (evt.charCode === 13 || evt.which === 13) { // enter key
      this.handleOnSubmit(evt)
    }
  }

  render() {
    const { isAdvancedOpen } = this.state
    const { categories, noPanel, isModal, filters, availableAttrs, isXS, isChanged } = this.props

    const condition = filters.get('condition', 0)
    const categoryId = !!filters ? filters.get('category_id') : undefined
    const categoryOptions = !!categories ? categories.map((category) => ({
      value: category.get('id'),
      title: category.get('name'),
      selected: `${categoryId}` === `${category.get('id')}`,
    })).toJS() : [{ value: null, title: 'All' }]
    if (!!categories) categoryOptions.unshift({ value: null, title: 'All' })

    const marketplaceListingSortBySelectOptions = Object.keys(MARKETPLACE_LISTING_SORY_BY).map((option) => ({
      value: option,
      title: MARKETPLACE_LISTING_SORY_BY[option],
      selected: sortBy === option,
    }))

    const conditionsOptions = Object.entries(MARKETPLACE_LISTING_CONDITIONS).filter(([key]) => key != 0).map(([key, value]) => ({
      value: value.value,
      title: value.title,
      selected: condition === value.value,
    }))
    conditionsOptions.unshift({'title':'', value:''})

    const Wrapper = isModal && !isXS ? Dummy : PanelLayout

    const query = filters.get('query', '')
    // const location = filters.get('location', '')
    const priceMin = filters.get('price_min', '')
    const priceMax = filters.get('price_max', '')
    const sortBy = filters.get('sort_by', 'newest')
    const categoryObj = categories.find((c) => `${c.get('id')}` === `${categoryId}`)
		const availableAttrsForCategory = !!categoryId && !!categoryObj && !!availableAttrs ? availableAttrs.get(categoryObj.get('slug')) : null
    const hasAvailableAttrsForCategory = availableAttrsForCategory && availableAttrsForCategory.size > 0
    const pxClass = isXS ? _s.px10 : isModal ? _s.px15 : _s.px5
    const ptClass = isXS ? _s.pt10 : _s.pt15
    const mainTitle = isXS ? 'Search' : 'Search Marketplace'
    
    return (
      <Wrapper noPadding noPanel={isXS || noPanel}>
        {
          isModal &&
          <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.jcCenter, _s.borderBottom1PX, _s.borderColorSecondary, _s.h53PX, _s.z4, _s.bgPrimary, _s.left0, _s.right0, _s.top0, _s.posSticky].join(' ')}>
            <div className={[_s.d, _s.h100PC, _s.flexRow, _s.py10, _s.w115PX, _s.mrAuto, _s.pl10].join(' ')}>
              <Button
                backgroundColor='tertiary'
                title='Close'
                className={[_s.h30PX, _s.w30PX, _s.aiCenter, _s.jcCenter, _s.mr10].join(' ')}
                onClick={this.handleOnClose}
                color='secondary'
                icon='close'
                iconSize='12px'
              />
              {
                isChanged &&
                <Button
                  radiusSmall
                  backgroundColor='none'
                  color='brand'
                  onClick={this.handleOnReset}
                  className={[_s.px10, _s.py5, _s.h100PC, _s.aiCenter, _s.jcCenter, _s.bgSubtle_onHover].join(' ')}
                >
                  <Text color='inherit' weight='bold'>
                    Reset
                  </Text>
                </Button>
              }
            </div>
            <Text weight='bold' size='extraLarge'>
              {mainTitle}
            </Text>
            <div className={[_s.d, _s.h100PC, _s.py10, _s.w115PX, _s.mlAuto, _s.pr10].join(' ')}>
              <Button
                radiusSmall
                isBlock
                backgroundColor='none'
                color='brand'
                isDisabled={!isChanged}
                onClick={this.handleOnSubmit}
                className={[_s.px5, _s.py5, _s.h100PC, _s.w84PX, _s.mlAuto, _s.aiCenter, _s.jcCenter, _s.bgSubtle_onHover].join(' ')}
              >
                <Text color='inherit' weight='bold'>
                  Search
                </Text>
              </Button>
            </div>
          </div>
        }

        <div className={[_s.d, ptClass, _s.pb10, pxClass].join(' ')}>
          <Input
            placeholder='Search Marketplace'
            prependIcon='search'
            value={query}
            // hasClear
            onChange={(value) => this.handleOnChangeAttr('query', value)}
            onKeyPress={this.keypress}
            id='mpl-search'
            hideLabel
            maxLength={120}
          />
        </div>

        <div className={[_s.d, pxClass, _s.py10].join(' ')}>
          <div className={[_s.d, _s.flexRow, _s.h30PX].join(' ')}>
            <Text size='large' weight='bold' className={_s.mb10}>
              Filters
            </Text>
            {
              !isModal && isChanged &&
              <div className={[_s.d, _s.w84PX, _s.mlAuto, _s.h30PX].join(' ')}>
                <Button
                  radiusSmall
                  backgroundColor='none'
                  color='brand'
                  onClick={this.handleOnSubmit}
                  className={[_s.px5, _s.h100PC, _s.mtNeg5PX, _s.aiCenter, _s.jcCenter, _s.bgSubtle_onHover].join(' ')}
                >
                  <Text color='inherit' weight='bold'>
                    Search
                  </Text>
                </Button>
              </div>
            }
          </div>
          
          {/* <div>
            <button
              className={[_s.d, _s.w100PC, _s.py5, _s.mt5, _s.mlNeg5PX, _s.mb5, _s.bgTransparent, _s.bgSubtle_onHover, _s.px5, _s.radiusSmall, _s.cursorPointer, _s.noUnderline].join(' ')}
              // onClick={this.}
            >
              <Text color='brand' weight='medium'>Location: United States · Everywhere</Text>
            </button>
          </div> */}

          <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.mt10, _s.mb10, _s.aiCenter].join(' ')}>
            <Text htmlFor='mpl-sort-by' tagName='label' weight='medium' className={[_s.minW84PX, _s.pr10].join(' ')}>Sort by</Text>
            <div className={[_s.d, _s.flexGrow1].join(' ')}>
              <Select
                id='mpl-sort-by'
                value={sortBy}
                onChange={({target: { value }}) => this.handleOnChangeAttr('sort_by', value)}
                options={marketplaceListingSortBySelectOptions}
              />
            </div>
          </div>

          <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.mt5, _s.mb10, _s.aiCenter].join(' ')}>
            <Text htmlFor='mpl-category' tagName='label' weight='medium' className={[_s.minW84PX, _s.pr10].join(' ')}>Category</Text>
            <div className={[_s.d, _s.flexGrow1].join(' ')}>
              <Select
                id='mpl-category'
                value={categoryId}
                onChange={({target: { value }}) => this.handleOnChangeAttr('category_id', value)}
                options={categoryOptions}
              />
            </div>
          </div>
   
          <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.mt5, _s.mb15, _s.aiCenter].join(' ')}>
            <Text htmlFor='mpl-price-min' tagName='label' weight='medium' className={[_s.minW84PX, _s.pr10].join(' ')}>Price</Text>
            <div className={[_s.d, _s.flexGrow1].join(' ')}>
              <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.jcCenter, _s.overflowHidden].join(' ')}>
                <div className={[_s.d, _s.w72PX, _s.flexGrow1, _s.overflowHidden].join(' ')}>
                  <Input
                    id='mpl-price-min'
                    placeholder='Min'
                    type='number'
                    value={priceMin}
                    maxLength={8}
                    onChange={(value) => this.handleOnChangeAttr('price_min', value)}
                    className={_s.overflowHidden}
                  />
                </div>
                <Text size='medium' className={[_s.d, _s.px10, _s.py10].join(' ')}>
                  to
                </Text>
                <div className={[_s.d, _s.w72PX, _s.flexGrow1, _s.overflowHidden].join(' ')}>
                  <Input
                    id='mpl-price-max'
                    placeholder='Max'
                    type='number'
                    value={priceMax}
                    maxLength={8}
                    onChange={(value) => this.handleOnChangeAttr('price_max', value)}
                    className={_s.overflowHidden}
                  />
                </div>
              </div>
            </div>
          </div>

          {
            (!isAdvancedOpen && !hasAvailableAttrsForCategory) &&
            <div className={[_s.d, _s.w100PC, _s.borderTop1PX, _s.borderColorSecondary, _s.mt5, _s.pt10, _s.pb5].join(' ')}>
              <button
                onClick={this.toggleIsAdvancedOpen}
                className={[_s.d, _s.w100PC, _s.flexRow, _s.py5, _s.aiCenter, _s.mt5, _s.bgTransparent, _s.cursorPointer, _s.outlineNone].join(' ')}
              >
                <Text size='medium' weight='medium' className={_s.mrAuto}>More options</Text>
                <Icon id='angle-right' className={_s.cPrimary} />
              </button>
            </div>
          }

          {
            (isAdvancedOpen || hasAvailableAttrsForCategory) &&
            <div>
              <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.mb15, _s.aiCenter].join(' ')}>
                <Text htmlFor='mpl-condition' tagName='label' weight='medium' className={[_s.minW84PX, _s.pr10].join(' ')}>Condition</Text>
                <div className={[_s.d, _s.flexGrow1].join(' ')}>
                  <Select
                    id='mpl-condition'
                    value={condition}
                    onChange={({target: { value }}) => this.handleOnChangeAttr('condition', value)}
                    options={conditionsOptions}
                  />
                </div>
              </div>

              {
                !!availableAttrsForCategory && availableAttrsForCategory.map((availableAttr) => {
                  const aaKey = availableAttr.get('key')
                  const aaType = availableAttr.get('type')
                  const aaTitle = availableAttr.get('title')
                  const aaSubtitle = availableAttr.get('subtitle')
                  const aaOptions = availableAttr.get('options')
                  const aaValue = filters.getIn(['attrs', aaKey])
                  const aaId = `marketplace-listing-attr-filter-${categoryId}-${aaKey}`
                  const isSelect = ['color', 'year', 'select'].indexOf(aaType) > -1
                  const isInput = ['input', 'number'].indexOf(aaType) > -1

                  let component
                  
                  // skipping textareas
                  if (isSelect) {
                    let aaActualOptions = 
                      ['select', 'multiple'].indexOf(aaType) > -1 ? [{title: '',value: ''}].concat(aaOptions.toJS()) :
                      aaType === 'color' ? MARKETPLACE_LISTING_COLOR_OPTIONS :
                      aaType === 'year' ? MARKETPLACE_LISTING_YEAR_OPTIONS : []

                    aaActualOptions = aaActualOptions.map((block) => ({
                      ...block,
                      selected: aaValue === block.value,
                    }))

                    component = (
                      <Select
                        value={aaValue}
                        isMultiple={aaType === 'multiple'}
                        onChange={({target: { value }}) => this.handleOnChangeAttr(['attrs', aaKey], value)}
                        options={aaActualOptions}
                        // isDisabled={isSubmitting}
                      />
                    )
                  } else if (isInput) {
                    component = (
                      <Input
                        id={aaId}
                        subtitle={aaSubtitle}
                        value={aaValue}
                        // isDisabled={isSubmitting}
                        maxLength={256}
                        type={aaType}
                        // placeholder='This marketplace item is about...'
                        onChange={(value) => this.handleOnChangeAttr(['attrs', aaKey], value)}
                      />
                    )
                  } else if (aaType === 'boolean') {
                    component = (
                      <Switch
                        label={aaTitle}
                        subtitle={aaSubtitle}
                        id={aaId}
                        // disabled={isSubmitting}
                        checked={aaValue}
                        onChange={(checked) => this.handleOnChangeAttr(['attrs', aaKey], checked)}
                        labelProps={{
                          weight: 'medium',
                          color: 'primary',
                        }}
                      />
                    )
                  }

                  if (!component) return null

                  return (
                    <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.mt5, _s.mb15, _s.aiCenter, _s.w100PC].join(' ')}>
                      {
                        aaType !== 'boolean' &&
                        <Text htmlFor={aaId} tagName='label' weight='medium' className={[_s.minW84PX, _s.pr10].join(' ')}>
                          {aaTitle}
                        </Text>
                      }
                      <div className={[_s.d, _s.flex1].join(' ')}>
                        {component}
                      </div>
                    </div>
                  )
                })
              }
            </div>
          }

          {
            !isXS &&
            <Button
              radiusSmall
              backgroundColor={!isChanged ? 'tertiary' : 'brand'}
              color={!isChanged ? 'tertiary' : 'white'}
              isDisabled={!isChanged}
              onClick={this.handleOnSubmit}
              className={[_s.mt5, _s.aiCenter].join(' ')}
            >
              <Text color='inherit' size='medium' weight='medium' align='center'>
                Submit Search
              </Text>
            </Button>
          }
        </div>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state) => ({
  filters: state.getIn(['marketplace_listing_search', 'filters']),
  isChanged: state.getIn(['marketplace_listing_search', 'isChanged']),
  categories: state.getIn(['marketplace_listing_categories', 'items']),
  categoriesIsFetched: state.getIn(['marketplace_listing_categories', 'isFetched']),
  availableAttrs: state.getIn(['marketplace_listing_search', 'available_attrs']),
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

const mapDispatchToProps = (dispatch) => ({
  onFetchMarketplaceListingCategories() {
    dispatch(fetchMarketplaceListingCategories())
  },
  onChangeMarketplaceListingSearchAttr(key, value) {
    dispatch(changeMarketplaceListingSearchAttr(key, value))
  },
  onFetchMarketplaceListingsBySearch(history) {
    dispatch(fetchMarketplaceListingsBySearch(history))
  },
  onResetMarketplaceListingSearch() {
    dispatch(marketplaceSearchReset())
  },
  onResetMarketplaceListingSearchInnerAttrs() {
    dispatch(resetMarketplaceListingSearchInnerAttrs())
  },
})

MarketplaceListingFilterPanel.propTypes = {
  isModal: PropTypes.bool,
  isXS: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketplaceListingFilterPanel))
